import { useEffect, useState } from 'react'

/**
 * Remaining spots shown next to the launch offer: starts at 5, drops to 4 after
 * one minute, to 3 after three minutes, and never goes below 3.
 */
export function useRemainingSpots() {
  const [spots, setSpots] = useState(5)

  useEffect(() => {
    const toFour = window.setTimeout(() => setSpots(4), 60 * 1000)
    const toThree = window.setTimeout(() => setSpots(3), 3 * 60 * 1000)

    return () => {
      window.clearTimeout(toFour)
      window.clearTimeout(toThree)
    }
  }, [])

  return spots
}
